import React from 'react';
import { Mail as LucideMail } from 'lucide-react';

interface MailProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Mail: React.FC<MailProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideMail width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Mail;
